import React, { useState, useEffect } from 'react';

function App() {
  const [message, setMessage] = useState('Loading...');

  useEffect(() => {
    const fetchMessage = async () => {
      try {
        // Replace this URL with your actual Cloudflare Worker URL
        const response = await fetch('https://cloudflare-hello-world-backend.markgreville.workers.dev');
        const data = await response.text();
        setMessage(data);
      } catch (error) {
        setMessage('Error fetching message');
        console.error('Fetch error:', error);
      }
    };

    fetchMessage();
  }, []);

  return (
    <div style={{
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: 'Arial, sans-serif'
    }}>
      <h1>{message}</h1>
    </div>
  );
}

export default App;
